<template>
    <a
        v-if="activePanel"
        class="header-icon"
        href="#"
        :title="titlePanel"
        data-toggle="tooltip-city"
        @click.prevent="togglePanel">
        <i class="fas fa-tasks"></i>
    </a>
</template>

<script>
    import ComponentMixin from '../mixins/ComponentMixin';

    export default {
        name: "accountableHeaderTool",
        mixins: [
            ComponentMixin,
        ],
        props: {
            propIdPanel: {
                type: String,
                default: 'accountable'
            },
        },
        data() {
            return {
                idPanel: this.propIdPanel,
            }
        },
        computed: {

        },
    };
</script>